import React from 'react';
import { capitalize } from '~/lib/helper/StringHelper';
import CopyToClipboardButton from './CopyToClipboardButton';
import './CopyableText.scss';

type CopyableTextProps = {
    /** Text to copy to clipboard. Required when children is not a plain string. */
    text?: string | null;
    contextText?: string;
    children: React.ReactNode;
};

export default class CopyableText extends React.Component<CopyableTextProps> {
    render() {
        const { text, contextText, children } = this.props;
        // text={null} (from nullable API fields) falls through to children extraction intentionally
        const textToCopy =
            text ?? (typeof children === 'string' || typeof children === 'number' ? String(children) : '');

        if (!textToCopy) return <>{children}</>;

        return (
            <span className="copyable-text">
                {children}
                <CopyToClipboardButton
                    text={textToCopy}
                    title={contextText ? `Copy ${contextText}` : undefined}
                    tooltipText={contextText ? `${capitalize(contextText)} copied` : undefined}
                    color="link"
                    size="sm"
                    className="copyable-text-btn"
                />
            </span>
        );
    }
}
